/*
  List of all CIE subjects that Paper.sc officially maintain.

  If you want Paper.sc to include additional subjects, report with either GitHub issues or paper.sc on-site feedback.
  Paper.sc will do its best to keep all contents up-to-date.
*/

module.exports = [
  {
    id: '0400',
    level: 'IGCSE',
    name: 'Art & Design',
  },
  {
    id: '0408',
    level: 'IGCSE',
    name: 'World Literature'
  },
  {
    id: '0410',
    level: 'IGCSE',
    name: 'Music'
  },
  {
    id: '0417',
    level: 'IGCSE',
    name: 'Information and Communication Technology'
  },
  {
    id: '0420',
    level: 'IGCSE',
    name: 'Computer Studies',
    deprecation: {
      successor: '0478',
      final: 'w14'
    }
  },
  {
    id: '0445',
    level: 'IGCSE',
    name: 'Design and Technology'
  },
  {
    id: '0450',
    level: 'IGCSE',
    name: 'Business Studies'
  },
  {
    id: '0452',
    level: 'IGCSE',
    name: 'Accounting'
  },
  {
    id: '0455',
    level: 'IGCSE',
    name: 'Economics'
  },
  {
    id: '0457',
    level: 'IGCSE',
    name: 'Global Perspectives'
  },
  {
    id: '0460',
    level: 'IGCSE',
    name: 'Geography'
  },
  {
    id: '0470',
    level: 'IGCSE',
    name: 'History'
  },
  {
    id: '0478',
    level: 'IGCSE',
    name: 'Computer Science'
  },
  {
    id: '0486',
    level: 'IGCSE',
    name: 'English - Literature'
  },
  {
    id: '0495',
    level: 'IGCSE',
    name: 'Sociology'
  },
  {
    id: '0500',
    level: 'IGCSE',
    name: 'English - First Language'
  },
  {
    id: '0502',
    level: 'IGCSE',
    name: 'Spanish - First Language'
  },
  {
    id: '0509',
    level: 'IGCSE',
    name: 'Chinese - First Language'
  },
  {
    id: '0510',
    level: 'IGCSE',
    name: 'English as a Second Language (Speaking endorsement)'
  },
  {
    id: '0511',
    level: 'IGCSE',
    name: 'English as a Second Language (Count-in speaking)'
  },
  {
    id: '0520',
    level: 'IGCSE',
    name: 'French - Foreign Language'
  },
  {
    id: '0522',
    level: 'IGCSE',
    name: 'English - First Language (UK)'
  },
  {
    id: '0530',
    level: 'IGCSE',
    name: 'Spanish - Foreign Language'
  },
  {
    id: '0538',
    level: 'IGCSE',
    name: 'Bahasa Indonesia'
  },
  {
    id: '0544',
    level: 'IGCSE',
    name: 'Arabic - Foreign Language'
  },
  {
    id: '0580',
    level: 'IGCSE',
    name: 'Mathematics'
  },
  {
    id: '0606',
    level: 'IGCSE',
    name: 'Mathematics - Additional'
  },
  {
    id: '0610',
    level: 'IGCSE',
    name: 'Biology'
  },
  {
    id: '0620',
    level: 'IGCSE',
    name: 'Chemistry'
  },
  {
    id: '0625',
    level: 'IGCSE',
    name: 'Physics'
  },
  {
    id: '0637',
    level: 'IGCSE',
    name: 'Child Development',
    deprecation: {
      successor: null,
      final: 'w19'
    }
  },
  {
    id: '0654',
    level: 'IGCSE',
    name: 'Co-ordinated Sciences'
  },
  {
    id: '0680',
    level: 'IGCSE',
    name: 'Environmental Management'
  },
  {
    id: '8681',
    level: 'AS',
    name: 'Chinese - Language (AS Level only)'
  },
  {
    id: '8682',
    level: 'AS',
    name: 'French - Language (AS Level only)'
  },
  {
    id: '8693',
    level: 'AS',
    name: 'English - Language (AS Level only)',
    deprecation: {
      successor: '9093',
      final: 'w13'
    }
  },
  {
    id: '8987',
    level: 'AS',
    name: 'Global Perspectives (AS Level only)',
    deprecation: {
      successor: '9239',
      final: 'w15'
    }
  },
  {
    id: '9093',
    level: 'A/s',
    name: 'English Language'
  },
  {
    id: '9231',
    level: 'A/s',
    name: 'Mathematics - Further'
  },
  {
    id: '9239',
    level: 'A/s',
    name: 'Global Perspectives and Research'
  },
  {
    id: '9389',
    level: 'A/s',
    name: 'History'
  },
  {
    id: '9608',
    level: 'A/s',
    name: 'Computer Science'
  },
  {
    id: '9609',
    level: 'A/s',
    name: 'Business'
  },
  {
    id: '9694',
    level: 'A/s',
    name: 'Thinking Skills'
  },
  {
    id: '9695',
    level: 'A/s',
    name: 'English - Literature'
  },
  {
    id: '9697',
    level: 'A/s',
    name: 'History',
    deprecation: {
      successor: '9389',
      final: 'w14'
    }
  },
  {
    id: '9698',
    level: 'A/s',
    name: 'Psychology'
  },
  {
    id: '9699',
    level: 'A/s',
    name: 'Sociology'
  },
  {
    id: '9700',
    level: 'A/s',
    name: 'Biology'
  },
  {
    id: '9701',
    level: 'A/s',
    name: 'Chemistry'
  },
  {
    id: '9702',
    level: 'A/s',
    name: 'Physics'
  },
  {
    id: '9705',
    level: 'A/s',
    name: 'Design & Technology'
  },
  {
    id: '9706',
    level: 'A/s',
    name: 'Accounting'
  },
  {
    id: '9707',
    level: 'A/s',
    name: 'Business Studies',
    deprecation: {
      successor: '9609',
      final: 'w15'
    }
  },
  {
    id: '9708',
    level: 'A/s',
    name: 'Economics'
  },
  {
    id: '9709',
    level: 'A/s',
    name: 'Mathematics'
  },
  {
    id: '9715',
    level: 'AL',
    name: 'Chinese (A Level only)'
  },
  {
    id: '9792',
    level: 'PreU',
    name: 'Physics'
  }
]
